import reactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import ReactGA from "react-ga4";
import { GA_MEASUREMENT_ID } from "./utils/analytics/analytics";

// Initialize Google Analytics
// Make sure to use your own Measurement ID
ReactGA.initialize(GA_MEASUREMENT_ID);

reactDOM.createRoot(document.getElementById("root")).render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

// You can send a custom event on page load if you want
ReactGA.send({
  hitType: "pageview",
  page: window.location.pathname + window.location.search,
});
